import { create } from 'zustand';

interface BuyerProductState {
    productId: string;
    product: Product | null;
    productLoading: boolean;
    selectedProductDetailId: string | null;
    productQuantity: number;
    shippingMethods: Array<ProductShippingMethod>;
    addressCountry: Array<{ key: string; value: string }>;
    promoProductGiveaway: BuyerPromoProductDetail | null;
    shipTo: string;
    specMetaLayerNameList: (string | null)[];
    lastChooseSpecMetaId: string | null;
}

export interface BuyerProductAction {
    setProductId: (id: string) => void;
    setProduct: (product: Product | null) => void;
    setProductLoading: (loading: boolean) => void;
    setSelectedProductDetailId: (id: string | null) => void;
    setProductQuantity: (quantity: number) => void;
    setShipTo: (country: string) => void;
    setShippingMethods: (methods: Array<ProductShippingMethod>) => void;
    setAddressCountry: (country: Array<{ key: string; value: string }>) => void;
    setPromoProductGiveaway: (promo: BuyerPromoProductDetail | null) => void;
    setSpecMetaLayerNameList: (layer: number, name: string, id: string) => void;
}

export const useBuyerProductStore = create<BuyerProductState & BuyerProductAction>(
    (set, get) => ({
        productId: '',
        product: null,
        productLoading: false,
        selectedProductDetailId: null,
        productQuantity: 1,
        shippingMethods: [],
        shipTo: 'TW', // default
        promoProductGiveaway: null,
        addressCountry: [],
        specMetaLayerNameList: [null, null, null],
        lastChooseSpecMetaId: null,
        setProductLoading: (loading) => set({ productLoading: loading }),
        setProductId: (id) => set({ productId: id }),
        setProduct: (product) => set({ product }),
        setSelectedProductDetailId: (id) => set({ selectedProductDetailId: id }),
        setProductQuantity: (quantity) => set({ productQuantity: quantity }),
        setShipTo: (country) => set({ shipTo: country }),
        setShippingMethods: (methods) => set({ shippingMethods: methods }),
        setAddressCountry: (country) => set({ addressCountry: country }),
        setPromoProductGiveaway: (promo) => set({ promoProductGiveaway: promo }),
        setSpecMetaLayerNameList: (layer, name, id) => {
            const { specMetaLayerNameList, product } = get();

            specMetaLayerNameList.splice(layer, 1, name);

            const specMetaLayerNameListStr = specMetaLayerNameList
                .filter((i) => !!i)
                .join('-');

            const { spec_details = [] } = product || {};

            const specDetail = spec_details.find((i) => {
                let specStr = '';

                const { spec_1, spec_2, spec_3 } = i;

                if (spec_1) {
                    specStr += spec_1;
                }

                if (spec_2) {
                    specStr += `-${spec_2}`;
                }

                if (spec_3) {
                    specStr += `-${spec_3}`;
                }

                return specStr === specMetaLayerNameListStr;
            });

            set({
                specMetaLayerNameList,
                lastChooseSpecMetaId: id,
                ...(specDetail?.id && { selectedProductDetailId: specDetail.id }),
            });
        },
    })
);
